module.exports = __webpack_public_path__ + "assets/img/11_759_big.6de77766.jpg";